export default {
  "Internal_Tools_B_Ejwk_Ynxz": "Se não quiser usar a nota de débito gerada pela {{brand_name}}, você poderá enviar uma nota de débito com o valor correspondente nesta fatura e a plataforma analisará o arquivo enviado.",
  "Internal_Tools_B_VhXm_dBVV": "Assinatura do responsável",
  "Internal_Tools_3_HrdF_EKQU": "Clique ou arraste para carregar",
  "Internal_Tools_2_UVGE_CWXm": "Insira o conteúdo especificado",
  "Internal_Tools_B_POgT_ZnaL": "ID do combustível",
  "Internal_Tools_B_BxVt_bJek": "Total",
  "Internal_Tools_3_BaNN_xmlP": "Desconto do posto (após) ({{currency_symbols}}) (≥0,05)",
  "Internal_Tools_B_baJJ_iGYw": "Você poderá baixar o arquivo após a confirmação.",
  "Internal_Tools_B_fCsH_wsFp": "Valor excessivo",
  "Internal_Tools_B_woQh_xwQt": "Confirme se seu endereço de e-mail é válido. Se precisar atualizá-lo, entre em contato com o administrador.",
  "Internal_Tools_2_lodd_TcJh": "Preço original total",
  "Internal_Tools_B_uuAb_JWOl": "Informações da nota de débito",
  "Internal_Tools_B_ZNHx_trjR": "Baixado com sucesso",
  "Internal_Tools_3_xIIl_Twme": "Preço original ({{currency_symbols}})",
  "Internal_Tools_B_JlRY_rljm": "Aprovada",
  "GDriver_B_bBJO_VXlJ": "Observações",
  "Internal_Tools_B_eiVg_xzja": "Tipo de desconto",
  "Internal_Tools_2_vAhn_Teln": "Clique ou arraste para carregar",
  "Internal_Tools_B_jTUw_mOnI": "Total de abastecimentos",
  "GDriver_Rate_WnXP_FNfu": "Um valor negativo indica que a Taxa de Serviço excede o subsídio da plataforma, mas não é necessário fazer nenhum pagamento à plataforma. Esse valor será transferido automaticamente para o próximo ciclo.",
  "GDriver_B_eDuK_afie": "Buscar abastecimentos",
  "Internal_Tools_B_jySx_dhBR": "Emitida em",
  "Internal_Tools_B_WWXN_VFkc": "{{variable_Name}}",
  "Internal_Tools_3_foFN_zztM": "Confirmar descontos enviados",
  "Internal_Tools_B_Tnvm_bEIP": "Insira o desconto do posto de gasolina",
  "GDriver_0714_xgaM_KAUq": "Mais",
  "Internal_Tools_B_xiIL_TLct": "Verifique sua pasta de spam.",
  "Internal_Tools_2_kwTR_iKCb": "Baixar o QR code",
  "Internal_Tools_B_UaAZ_MOmJ": "Nº da conta bancária",
  "Internal_Tools_2_tnYP_zmjj": "Set",
  "Internal_Tools_2_TJjb_Wvzj": "Desconto total do posto de gasolina",
  "Internal_Tools_B_vlJT_UqQb": "Cidade",
  "Internal_Tools_B_qWSm_gsCg": "Recusada",
  "Internal_Tools_B_znDH_qMZE": "O desconto do posto de gasolina não pode ultrapassar o preço original do combustível",
  "Internal_Tools_B_GzUD_pXnf": "Cancelar",
  "Internal_Tools_2_VunY_IMzD": "Hora de início",
  "GDriver_B_fCnp_mBtP": "Valor por litro com desconto",
  "Internal_Tools_B_MtXg_YOBx": "Quer mesmo exibir o combustível? Depois disso, ele aparecerá para os usuários no {{brand_name}}Abastece.",
  "Internal_Tools_2_yMpt_EUyT": "Preço unitário após o desconto",
  "Internal_Tools_3_KtGv_jKWY": "Importar descontos",
  "Internal_Tools_B_gPKb_TdEh": "Não foi possível salvar",
  "GDriver_B_ObZo_cyru": "Valor total após a aplicação do desconto = valor total original - valor total do desconto",
  "Internal_Tools_B_VTCU_CeUB": "Anexo (opcional)",
  "Internal_Tools_B_myuj_LLtq": "Não foi possível limpar as alterações",
  "Internal_Tools_B_fhzE_VyPH": "Confirmar",
  "Internal_Tools_B_IMVU_okmF": "Salvar",
  "GDriver_Rate_Mkpg_QdjY": "Estratégia de taxa de serviço",
  "Internal_Tools_2_Ctnh_PCZG": "Desconto do posto",
  "Internal_Tools_B_smNl_fJqE": "Rejeitado pela {{brand_name}}",
  "GDriver_Rate_WEmP_UhBp": "Esta página exibe pedidos associados dos últimos três meses.",
  "Internal_Tools_B_rLLZ_yAjR": "Salvo com sucesso",
  "GDriver_B_zaMj_EEIS": "Status do abastecimento",
  "Internal_Tools_2_fHjz_yFMU": "Valor a receber total esperado",
  "GDriver_B_eFya_eIeE": "Preço original por litro",
  "Internal_Tools_B_zfQV_KiFx": "O novo desconto do posto de gasolina é menor do que o desconto anterior. Reduzir o desconto pode diminuir as vendas. Confirme que você inseriu o valor de desconto correto.",
  "Internal_Tools_B_nRdi_lIgp": "Preço original do combustível",
  "Internal_Tools_B_aXSr_paiK": "Ajustar",
  "Internal_Tools_B_FmOf_prqv": "Banco",
  "Internal_Tools_B_jmKa_NsET": "Confirmar envio",
  "GDriver_B_QzYe_htgo": "Valor total original",
  "Internal_Tools_B_HXec_cozR": "Última atualização de desconto em",
  "Internal_Tools_B_OZGf_eIJG": "Em exibição",
  "Internal_Tools_2_NMsR_VnbC": "Volume abastecido",
  "Internal_Tools_B_ewyj_jVhQ": "Analisar",
  "GDriver_0714_ZRFh_DHxb": "Sugestões de negócios",
  "Internal_Tools_B_CieE_fzIW": "Selecione",
  "Internal_Tools_2_RzTq_mRBg": "Litros",
  "Internal_Tools_B_bgoN_mIid": "Cancelar",
  "GDriver_0714_WCbg_WbRd": "Avaliações do cliente",
  "Internal_Tools_B_DDWp_neUq": "Valor do pagamento: {{brand_name}}",
  "Internal_Tools_B_tZsi_sztT": "Informações básicas",
  "Internal_Tools_B_hlMU_cWRx": "Quer mesmo deixar de exibir esse combustível? Depois disso, ele não aparecerá mais para os usuários no {{brand_name}}Abastece. Tenha cautela ao executar essa ação.",
  "Internal_Tools_2_KxKS_MqMX": "Se algum abastecimento não for localizado, clique aqui.",
  "GDriver_0714_LFVn_YVQH": "Este gráfico mostra o conteúdo de texto de avaliações de 1 a 4 estrelas nos últimos 60 dias.",
  "Internal_Tools_B_eMoB_KRAm": "Gerenciamento de faturas",
  "Internal_Tools_2_rCeC_qXKy": "Seu ajuste de valor (de {{bill_amount}} para {{bill_adjusted_amount}}) e a nota de débito enviada foram rejeitados pela {{brand_name}}. Faça as alterações com base no motivo da rejeição e depois reenvie a confirmação.",
  "Internal_Tools_3_eVmP_QNhY": "Formato de arquivo ou cabeçalho inválido. Envie novamente.",
  "Internal_Tools_B_sElL_adaZ": "Nome da empresa",
  "GDriver_0714_BHFL_POgC": "Pontuação",
  "GDriver_0714_rszt_qfQa": "Principais tags com avaliações de 1 a 4 estrelas",
  "GDriver_B_pcAA_HWoB": "Calculando",
  "Internal_Tools_B_GaWI_nvTf": "A fatura de {{Gas_Station_Name}} ({{Bill_Periods}}) foi paga com sucesso na sua conta. Valor: {{Bill_adjusted_amount}}. Por favor, confirme.",
  "Internal_Tools_B_sFAV_iacx": "Cancelar",
  "Internal_Tools_B_gans_zqgx": "Para nos ajudar a melhor atender você, por favor, informe por que deseja deixar de exibir esse combustível. Obrigado!",
  "Internal_Tools_2_CeJk_uQAq": "Insira o(s) motivo(s) específico(s)",
  "Internal_Tools_B_UilM_nfcx": "Descrição do item",
  "Internal_Tools_2_uwVq_MMJw": "Envie um arquivo em formato .pdf, .jpeg, .jpg, .png ou .xlsx (até 10 MB)",
  "Internal_Tools_B_vmUO_nwSd": "A plataforma ajustará o preço real recebido pelo usuário que fizer o abastecimento e arcará com a diferença entre o valor total do desconto e o desconto do posto de gasolina.",
  "Internal_Tools_2_MTMo_BaMI": "Abr",
  "Internal_Tools_B_Hsqp_HMYm": "Ação do posto:",
  "Internal_Tools_B_gOmi_rvrr": "Nota de débito",
  "Internal_Tools_B_KXEV_WsEc": "Deseja apagar as alterações?",
  "Internal_Tools_2_AdFu_XwYF": "Se você sair, o ajuste feito ao valor será apagado. Deseja salvar o valor inserido antes de sair?",
  "Internal_Tools_B_jAUX_xIGC": "Geração de fatura",
  "Internal_Tools_B_dgQy_EcYg": "Para",
  "GDriver_Rate_Qnme_nHUC": "Ver fatura principal",
  "Internal_Tools_2_RNZQ_cXCd": "Você ajustou {{num}} abastecimento(s). Depois do ajuste, o valor de pagamento adicional da conta é {{{adjustment_amount_orders}}}.",
  "GDriver_0714_uzWo_CJsO": "Os dados são atualizados diariamente",
  "Internal_Tools_B_LXmx_VUXh": "Salvar",
  "GDriver_Rate_kqZa_VLnH": "Pedidos ausentes",
  "Internal_Tools_3_IpMC_owwp": "Entre em contato com o Atendimento ao Cliente durante o horário de atendimento",
  "Internal_Tools_2_zdDd_lJmX": "O valor inserido precisa ser menor que o preço original total",
  "Internal_Tools_2_CnTD_lDFG": "Sem dados",
  "Internal_Tools_B_ntHL_WvCO": "Aguardando confirmação",
  "Internal_Tools_B_BuUG_bfZR": "Para ver mais registros, acesse {Registro de alterações de desconto}",
  "Internal_Tools_2_ThRd_xnHT": "Dia",
  "Internal_Tools_2_lYFD_lpHi": "Jul",
  "GDriver_Rate_gAPX_UqhX": "Fatura ajustada",
  "GDriver_0714_aNaU_XPkE": "Últimos 15 dias",
  "Internal_Tools_2_nitD_IURE": "Valor de pagamento da {{brand_name}} (depois do ajuste)",
  "Internal_Tools_B_cmzd_RyDx": "Pago pela {{brand_name}}",
  "Internal_Tools_B_HGyM_msoC": "Operador",
  "GDriver_B_FKZH_bmer": "Nome do combustível",
  "GDriver_0714_Ufzq_DXfp": "Atualizado diariamente",
  "Internal_Tools_2_uHFh_xZXJ": "Quantidade de abastecimentos",
  "GDriver_0714_BIkK_hHQF": "Se houver menos de 10 avaliações, elas não serão exibidas aos usuários",
  "Internal_Tools_B_HMKF_pPXI": "Enviar nota de débito por conta própria (opcional)",
  "GDriver_B_AIST_uhIx": "Total de litros",
  "Internal_Tools_2_MwJt_SFwg": "Observações",
  "Internal_Tools_B_MSqS_OLZh": "Tipo de conta",
  "Internal_Tools_B_NorW_yQid": "Retorno da {{brand_name}}: a solicitação de ajuste foi aprovada. Por favor, faça a confirmação.",
  "Internal_Tools_2_qMwU_rvhb": "Ano",
  "GDriver_B_HAsu_pUhW": "Reembolsado",
  "GDriver_B_fgYV_RobR": "Valor total do desconto",
  "Internal_Tools_6_VKVq_bQAl": "Atenção",
  "Internal_Tools_B_cffn_cmkL": "Baixar detalhes da fatura",
  "GDriver_B_KVkL_ZHjF": "Últimos 7 dias",
  "Internal_Tools_B_elSJ_gIZG": "Envie um arquivo em formato .pdf, .jpeg, .jpg ou .png (até 10 MB)",
  "Internal_Tools_2_hhOc_JJAW": "Início",
  "Internal_Tools_B_Fngc_WSSS": "Desconto do posto de gasolina",
  "Internal_Tools_B_MBuz_Ymtp": "Nome do beneficiário",
  "Internal_Tools_B_fDkS_eMyr": "Operador",
  "Internal_Tools_2_CrYy_JcNy": "Escanear o código QR com seu celular",
  "GDriver_Rate_XEUc_iloC": "Motivo específico",
  "Internal_Tools_2_NLCP_rEFO": "O recurso de análise não está disponível em dispositivos móveis. Use a versão para PC.",
  "Internal_Tools_2_pHZw_WxBd": "Preço original",
  "Internal_Tools_2_NgEj_cmVx": "Seg",
  "Internal_Tools_2_kjSs_qYzP": "Out",
  "Internal_Tools_B_wUPq_CDsX": "Nº da conta:",
  "Internal_Tools_B_cclU_VMMo": "Código da agência:",
  "GDriver_0714_cdPT_JKgL": "{{Rating}} ({{Ratings_amount}})",
  "GDriver_Rate_Vgyp_nqsD": "Nº abastecimentos",
  "Internal_Tools_2_BecI_qaZY": "Fim",
  "Internal_Tools_B_MEDg_tikP": "Informações básicas",
  "Internal_Tools_2_kUxV_iMJC": "Intervalo de tempo",
  "GDriver_B_Gxva_EpVj": "Concluído",
  "Internal_Tools_2_JYyb_uJky": "Sair",
  "Internal_Tools_B_HPAz_LoqE": "Motivo da rejeição da {{brand_name}}: {{variable_name}}",
  "Internal_Tools_B_iiVf_pSOO": "Detalhes do ajuste do desconto do combustível",
  "GDriver_0714_qESd_UwOO": "Contagem de avaliações",
  "Internal_Tools_B_PYRp_eEhi": "Baixar resumo das contas por e-mail",
  "GDriver_0714_rbBM_AgJg": "Analisar distribuição de texto",
  "Internal_Tools_B_JKwQ_LMMp": "Nome do posto",
  "Internal_Tools_B_NrRO_hyjF": "Cidade – Estado",
  "Internal_Tools_B_eXuC_kQPR": "Outro",
  "Internal_Tools_2_xUdt_pOMS": "Quantidade total de combustível",
  "Internal_Tools_B_Kcmr_GPux": "Nota de débito inválida",
  "Internal_Tools_B_JBUV_TzRT": "Confirme se deseja mesmo apagar as alterações feitas. Após a confirmação, o registro de alterações será apagado.",
  "Internal_Tools_B_cWRX_eefe": "Valor da fatura",
  "Internal_Tools_B_ABGx_NgcF": "{{appendix}}",
  "Internal_Tools_3_hYrd_MHvK": "Nome do combustível",
  "Internal_Tools_B_GZrT_BIFB": "Quantidade total de combustível (litros)",
  "Internal_Tools_2_Xueq_krcz": "Valor do ajuste",
  "Internal_Tools_2_MhRN_FNUA": "Total de litros de combustível líquido",
  "Internal_Tools_2_ftnF_zZMU": "abastecimento(s) não localizado(s) enviado(s)",
  "GDriver_Rate_zQlW_UZCR": "Valor do período atual",
  "Internal_Tools_B_hWZz_Swrm": "Confirmação de exibição do combustível",
  "Internal_Tools_B_AeyK_bIak": "Exibir",
  "Internal_Tools_2_dgvn_fQpU": "Envie as evidências que comprovam os abastecimentos não localizados (em formato .xlsx)",
  "Internal_Tools_3_GQxF_vack": "Nº",
  "Internal_Tools_2_eBtC_jSgY": "Hora de término",
  "GDriver_Rate_ujyz_RSOz": "Prova de pedido ausente",
  "Internal_Tools_B_wFVO_wUGQ": "Número de telefone",
  "Internal_Tools_B_owWu_mwVa": "Endereço",
  "Internal_Tools_B_gYZs_ulOj": "Última atualização em",
  "Internal_Tools_B_VLNO_dwPV": "Limpar alterações",
  "GDriver_0714_RTbN_YBVq": "{{Ratings_amount}} avaliações",
  "Internal_Tools_B_yuff_FSjp": "Cancelar",
  "Internal_Tools_B_mbwq_mnym": "A fatura de {{Gas_Station_Name}} ({{Bill_Periods}}) foi rejeitada pela {{brand_name}}. Acesse o {{brand_name}}Abastece para confirmação.",
  "GDriver_Rate_vcNN_TOwL": "Ver fatura ajustada",
  "Internal_Tools_2_pACZ_Yzam": "Até {{num}} abastecimentos podem ser ajustados",
  "Internal_Tools_B_OBgN_mTrt": "Não exibir",
  "Internal_Tools_B_lxML_RcGh": "Motivo para não exibir",
  "Internal_Tools_2_XHWq_gRnu": "Mostrar filtros",
  "Internal_Tools_2_oVai_vFAT": "Valor do pagamento: {{brand_name}}",
  "GDriver_0714_yAyF_HyFt": "Visualizar",
  "GDriver_Rate_LQtQ_IRrX": "Valor inicial",
  "Internal_Tools_2_VmKe_ukvq": "Falha no envio",
  "Internal_Tools_2_nHHF_Crlf": "A nota de débito enviada foi rejeitada pela {{brand_name}}. Faça as alterações com base no motivo da rejeição e depois reenvie a confirmação.",
  "GDriver_0714_aCJL_sWTy": "Contagem de avaliações / Contagem de transações",
  "Internal_Tools_6_UFDK_QNkM": "Quer mesmo ajustar o desconto do combustível para este posto de gasolina? Depois de confirmar, o novo desconto se tornará válido assim que o posto de gasolina for exibido.",
  "Internal_Tools_2_XuZF_XpcU": "Não foi possível salvar. Tente novamente.",
  "Internal_Tools_B_mIlH_Fkgh": "Ações",
  "GDriver_B_mKhM_HPiy": "Cancelado",
  "Internal_Tools_B_nBFs_LXko": "Se as informações estiverem incorretas, entre em contato com nossa equipe de vendas ({{sales_email}}) para solicitar a correção.",
  "Internal_Tools_3_NlPw_QlkA": "Grande desconto",
  "Internal_Tools_B_btRf_kJeN": "O total de usuários com abastecimentos nas condições selecionadas (inclui apenas usuários com abastecimentos não cancelados e concluídos com sucesso)",
  "Internal_Tools_B_Ajtt_rxuw": "Banco:",
  "Internal_Tools_B_UOfz_hTHC": "Ver",
  "Internal_Tools_B_qxrM_NiCE": "A margem de lucro está muito baixa para o posto de gasolina oferecer descontos",
  "Internal_Tools_B_ljFB_DAJr": "Insira o desconto do posto de gasolina abaixo e depois clique no botão Exibir para que o combustível seja exibido.",
  "Internal_Tools_2_aRCX_mimf": "Abastecimentos “cancelados” filtrados",
  "Internal_Tools_B_AWqL_aCAL": "CNPJ do posto",
  "Internal_Tools_B_SxmG_vBav": "A fatura de {{Gas_Station_Name}} ({{Bill_Periods}}) foi paga. Por favor, confirme.",
  "Internal_Tools_3_TwYi_hyXj": "Valor ajustado?",
  "Internal_Tools_B_eYAC_Clpm": "Valor ajustado de {{bill_amount}} para {{bill_adjusted_amount}}",
  "Internal_Tools_B_hORS_vRXF": "Não exibido",
  "Internal_Tools_B_biCt_AXoR": "Envie um arquivo no formato .pdf, .jpeg, .jpg ou .png",
  "Internal_Tools_B_jDZP_kDzC": "Desconto do posto de gasolina (antes da alteração)",
  "Internal_Tools_B_Ghxe_pCWK": "Válida",
  "Internal_Tools_2_TEGY_SONK": "Desconto do posto de gasolina por unidade",
  "Internal_Tools_B_MCil_Xcno": "Item",
  "Internal_Tools_B_bNIZ_hAGP": "Digite aqui",
  "GDriver_B_apbe_dntZ": "Nome do posto de gasolina",
  "Internal_Tools_B_Pmry_OGIf": "Dados para depósito",
  "Internal_Tools_B_fZhR_srgn": "Carimbo",
  "Internal_Tools_3_SOIx_QzGa": "ID do combustível",
  "Internal_Tools_B_jpOd_zpOd": "Emitida/enviada em",
  "Internal_Tools_B_WuVw_UhVj": "ID da nota de débito",
  "Internal_Tools_2_QPsS_gHnw": "Cancelar",
  "GDriver_B_CkMV_hWxl": "Esta semana",
  "GDriver_0714_sPhj_umcC": "Detalhes da avaliação dos usuários",
  "Internal_Tools_B_Bkts_QgGl": "Motivo: {{reason}}",
  "Internal_Tools_B_TGdl_pQYC": "Preço",
  "Internal_Tools_Ops_ZrXX_jLfJ": "Total de {{order_quantity}} entradas",
  "Internal_Tools_B_Xddd_srny": "Gerenciamento de combustíveis",
  "Internal_Tools_B_EAzs_ZGvU": "Nota de débito",
  "Internal_Tools_3_fqmg_VDbw": "Confirmar e enviar",
  "GDriver_0714_CcNI_rsSC": "Análise das tendências",
  "Internal_Tools_B_XWSG_ifsw": "Registro de alterações recentes",
  "Internal_Tools_2_YBkJ_wHPL": "Min",
  "GDriver_B_JAhN_lxfe": "Valor total após a aplicação do desconto",
  "Internal_Tools_B_ODcX_VDxG": "Ação",
  "Internal_Tools_B_KTZQ_wBFq": "Ações",
  "Internal_Tools_B_upRN_xOJy": "Emitida/enviada por",
  "Internal_Tools_B_sCvg_DfYw": "Período de faturamento",
  "Internal_Tools_B_JAZc_kfnw": "Recusada",
  "Internal_Tools_B_EzRf_TXVr": "Não recebeu o e-mail?",
  "Internal_Tools_B_elge_fQzz": "Confirmação do ajuste do desconto",
  "Internal_Tools_B_wzLs_Zbqj": "O total de abastecimentos nas condições selecionadas (inclui apenas abastecimentos não cancelados e concluídos com sucesso)",
  "GDriver_Rate_CNuf_gFsJ": "Taxa {{Platform_name}}",
  "GDriver_B_aseD_RLUl": "Código de desconto",
  "GDriver_B_JGKl_aMeG": "Extratos da conta",
  "Internal_Tools_6_Knpn_VdKB": "Quer mesmo exibir este combustível? Depois de confirmar, o combustível aparecerá no {{brand_name}}Abastece assim que o posto de gasolina for exibido.",
  "Internal_Tools_2_SAIb_RpwU": "Confirmar saída?",
  "Finance_120version_All_XvPp": "Tudo",
  "GDriver_B_duAf_AXjt": "Status da transação",
  "Internal_Tools_B_xfZE_YVTX": "A fatura de {{Gas_Station_Name}} ({{Bill_Periods}}) foi rejeitada pela {{brand_name}}. Confirme.",
  "Internal_Tools_B_HlmN_NmVE": "E-mail do operador",
  "GDriver_0714_YEsn_YJNV": "Motivos de baixa avaliação",
  "Internal_Tools_B_IdjN_nrct": "Ver nota de débito",
  "Internal_Tools_B_PuzK_uAgA": "Desconto total",
  "Internal_Tools_B_rVeY_zhxF": "Status de exibição",
  "Internal_Tools_2_swod_ShaV": "Nov",
  "GDriver_Rate_qAKf_Tuxy": "Valor do pagamento",
  "GDriver_B_ypBU_eWTX": "Total de abastecimentos",
  "GDriver_B_voCc_twWK": "Total de usuários",
  "Internal_Tools_B_iuIG_bARf": "Exibir",
  "GDriver_B_hxEf_LgnF": "Baixar fatura detalhada",
  "Internal_Tools_B_maAi_LDaH": "Confirmar",
  "Internal_Tools_B_yKrW_kCRv": "Nota de débito enviada",
  "Internal_Tools_B_KcBD_VdDF": "Quantidade",
  "Internal_Tools_2_dhrn_UOGT": "Ocultar filtros",
  "Internal_Tools_B_eswZ_toaj": "Confirme a fatura de {{Gas_Station_Name}} ({{Bill_Periods}})",
  "Internal_Tools_4_Cwym_IJSI": "Apenas arquivos .xlsx são aceitos",
  "Internal_Tools_2_ijcp_zTQW": "Selecione os abastecimentos para ajustar o valor",
  "GDriver_Rate_OhXE_fUdr": "O valor ajustado da fatura não pode ser negativo. Edite antes de enviar",
  "GDriver_B_BtUy_wEbU": "Valor total do desconto",
  "Internal_Tools_4_FPhj_TwAr": "Informações anexas de abastecimentos não localizados",
  "Internal_Tools_B_ljtx_sZET": "Confirme que deseja deixar de exibir o combustível",
  "GDriver_0714_yFdx_MsMQ": "Avaliações positivas",
  "Internal_Tools_B_scNd_qcZP": "Concluída",
  "Internal_Tools_B_xSlQ_mCao": "Ação do posto: {{variable_name}}",
  "Internal_Tools_3_kwOM_UZuX": "CNPJ",
  "GDriver_B_gltl_Hlxo": "Nome do posto de gasolina",
  "Internal_Tools_B_zqAk_QFls": "Só é possível enviar um arquivo",
  "Internal_Tools_2_ShWE_pqHC": "Fev",
  "GDriver_0714_uhMc_pcOa": "Avaliação média nos últimos 60 dias",
  "Internal_Tools_B_rSBU_GsMk": "Pagamento bancário",
  "Internal_Tools_B_fudE_UQpX": "Confirme se as informações a seguir estão corretas:",
  "Internal_Tools_B_bgHa_HtAx": "Histórico da nota de débito",
  "GDriver_B_plYK_TBWO": "Este mês",
  "Internal_Tools_B_fEFC_wWrr": "Status da fatura",
  "GDriver_Rate_Ypvy_hqGY": "Detalhes do ajuste de valor",
  "Internal_Tools_B_STXC_iwsY": "Detalhes da reconciliação e pagamento",
  "Internal_Tools_B_SPnJ_IQAe": "Gerenciamento de descontos",
  "GDriver_Rate_TJDL_AuGR": "Lista de faturas associadas",
  "Internal_Tools_2_Nqhz_aeKd": "O valor da fatura informado é igual ao calculado pela plataforma. Modifique o valor.",
  "Internal_Tools_B_YhSM_fNbO": "CNPJ:",
  "Internal_Tools_B_HmDv_lOyc": "Enviado com sucesso",
  "Internal_Tools_B_BrTt_fcQx": "E-mail",
  "Internal_Tools_2_aHcj_MNUx": "Volume total de combustível gasoso",
  "Internal_Tools_B_dsMv_ZMMu": "O novo desconto do posto de gasolina é menor do que o limite atual da plataforma ({{lower_limit}}) e não pode ser salvo. Confira o valor e insira-o novamente.",
  "Internal_Tools_B_Nckm_MRzP": "Fornecedor aprovou o valor da fatura no {{brand_name}}Abastece às {{time}}",
  "GDriver_B_SXwK_HWoB": "Valor total original",
  "Internal_Tools_B_SahY_dqBb": "Código da agência",
  "GDriver_B_kmNL_caEY": "Nível de desconto ao abastecer",
  "GDriver_B_gElW_SXdK": "Valor total após a aplicação do desconto",
  "Internal_Tools_B_WGhe_oKSS": "Motivo técnico (internet/falta de energia/problema no PDV)",
  "Internal_Tools_B_qbYe_OgQa": "(calculado pela {{brand_name}})",
  "GDriver_B_mSPV_rbLY": "Você não tem permissão para acessar essa página. Entre em contato com o administrador do sistema.",
  "Internal_Tools_2_VPzK_SlSn": "Mai",
  "Internal_Tools_2_tepY_hnPO": "Disponível diariamente das {{time_start}} às {{time_end}}",
  "Internal_Tools_B_RxoO_bhVS": "Ajuste do desconto do posto de gasolina iniciado",
  "Internal_Tools_B_oGAj_HAts": "Nome da empresa",
  "Internal_Tools_3_Okwr_nrog": "Conteúdo inválido. Baixe o arquivo para mais informações.",
  "Internal_Tools_B_kMWu_eiOM": "Enviado com sucesso!",
  "Internal_Tools_Ops_vEHa_XFxU": "CNPJ",
  "Internal_Tools_2_WOcZ_xmgT": "Número de arquivos que podem ser enviados: {{num}}",
  "Internal_Tools_2_lSBW_srOU": "O recurso de ajuste não está disponível em dispositivos móveis. Use a versão para PC.",
  "Internal_Tools_B_aBZb_ubgd": "Nome detalhado do combustível",
  "Internal_Tools_B_fKyZ_jQjs": "Estratégia de desconto",
  "Internal_Tools_B_npwb_kifs": "Se achar que o valor de pagamento está incorreto, clique {aqui} para fazer o ajuste.",
  "Internal_Tools_B_vtbb_fwKe": "O relatório será enviado ao seu endereço de e-mail {{email_address}}.",
  "Internal_Tools_2_sVTx_zDXt": "Valor a receber do posto de gasolina – Cálculo da {{brand_name}}",
  "Internal_Tools_2_fLkn_zUya": "ID do abastecimento",
  "Internal_Tools_2_guyK_dNWP": "Hora",
  "Internal_Tools_B_NrnD_CueJ": "O tamanho máximo do arquivo é 10 MB",
  "Internal_Tools_2_DgKa_MWcm": "Mar",
  "GDriver_0714_PlUK_vnZD": "Contagem de transações",
  "Internal_Tools_B_roDY_yNHt": "Alterações limpas com sucesso",
  "Internal_Tools_B_LhVI_fQhq": "{{reason}}",
  "Internal_Tools_B_bNjt_LhgO": "Nome do combustível",
  "Internal_Tools_B_klis_ZshW": "Nº",
  "Internal_Tools_B_mVaF_oiOh": "Como isso é feito em função do ajuste dinâmico da plataforma, nenhum pagamento é necessário.",
  "Internal_Tools_B_ljZA_uzFp": "ID do cliente",
  "Internal_Tools_2_ShSC_iPXl": "Envie um arquivo",
  "Internal_Tools_B_qIkJ_vecB": "Desconto do posto",
  "Internal_Tools_B_btLV_laDf": "Analisar histórico",
  "Internal_Tools_2_dkIt_zOwG": "Preencha os detalhes do abastecimento não localizado e o valor total esperado a ser pago pela {{brand_name}}",
  "Internal_Tools_2_nsxA_ILyQ": "Valor original do pagamento da {{brand_name}}",
  "GDriver_B_OgXv_iCAL": "Total",
  "GDriver_B_GCvq_HEoF": "Total de litros de todos os abastecimentos nas condições selecionadas",
  "Internal_Tools_B_sGXH_MbOC": "Ver",
  "Internal_Tools_2_GSUg_zEJU": "Total de litros de combustível líquido de todos os abastecimentos nas condições selecionadas",
  "Internal_Tools_6_YUwb_Jftq": "Este combustível não está ativado. Não é possível modificar.",
  "Internal_Tools_3_qadq_ftID": "Enviar",
  "GDriver_Rate_kKDM_ZGLr": "Pedidos com problema",
  "GDriver_Rate_HfEU_JVUS": "Taxa de serviço cobrada",
  "Internal_Tools_B_SCdD_gYeo": "Concluída",
  "Internal_Tools_2_KVNS_Tidn": "Jan",
  "GDriver_B_QGRk_fEQb": "Baixar resumo das faturas",
  "Internal_Tools_B_alkr_LDhX": "Desconto de percentual fixo",
  "GDriver_B_gBCW_tqrc": "Litros",
  "GDriver_B_uGTO_zzvy": "ID do abastecimento",
  "Internal_Tools_3_mbZw_bLfk": "Etapa 1: Baixar modelo com base no filtro",
  "Internal_Tools_B_Pfxu_ZJtI": "Total",
  "GDriver_Rate_lICZ_WYxq": "Valor final",
  "Internal_Tools_3_AkBo_IAuy": "Cancelar",
  "GDriver_Rate_zCyR_AFnE": "O valor da fatura foi ajustado para {{adjusted_amount}}",
  "Internal_Tools_3_Famx_vWjX": "Baixar modelo",
  "Internal_Tools_B_FGcc_qKjk": "Cancelar",
  "Internal_Tools_B_Hiye_IHzm": "Ajustes salvos",
  "GDriver_B_puJr_wfVl": "A conta foi bloqueada. Entre em contato com o administrador do sistema.",
  "Internal_Tools_3_LLVV_gEyO": "Desconto do posto (antes) ({{currency_symbols}})",
  "Internal_Tools_2_AzpT_hWwx": "Opções rápidas",
  "Internal_Tools_3_HfRl_hfLy": "Envie no máximo 1.000 entradas por vez. Envie novamente.",
  "Internal_Tools_B_lKPj_Cfrr": "Seu relatório chegará no seu endereço de e-mail {{email_address}} em breve.",
  "Internal_Tools_2_HapJ_nsTk": "Ago",
  "Internal_Tools_2_jfyZ_sGtA": "Dez",
  "GDriver_0714_xdsg_usTU": "Negativas",
  "Internal_Tools_B_sYEO_YiqD": "Aprovada",
  "Internal_Tools_B_dARX_ILFp": "Preço com desconto",
  "Internal_Tools_2_SKHb_kzAe": "Nome do combustível",
  "Internal_Tools_B_HxGE_tKzV": "Desconto do posto de gasolina (após a alteração)",
  "Internal_Tools_B_SOMA_BAzh": "Diferença do desconto",
  "Internal_Tools_2_ZlCC_JcRC": "Sair",
  "GDriver_0714_xaoL_Ugzz": "Principais reclamações",
  "Internal_Tools_B_jbbQ_xdOx": "Motivo: {{reason}}",
  "GDriver_0714_SEEy_bOKG": "Este gráfico mostra tags com avaliações de 1 a 4 estrelas nos últimos 60 dias.",
  "Internal_Tools_2_KOqv_srKp": "Atendimento ao Cliente",
  "Internal_Tools_B_EnBP_ecCZ": "Baixar",
  "Internal_Tools_B_ooyJ_mlNY": "Análise do posto de gasolina",
  "Internal_Tools_2_inUB_pEQn": "Salvar e sair",
  "Internal_Tools_2_nbUx_lwXP": "Período",
  "GDriver_B_cjbU_mTvI": "Desconto do posto de gasolina",
  "GDriver_0714_woUE_eHbz": "Último mês",
  "GDriver_B_WUOr_ceCL": "Centro de dados",
  "Internal_Tools_B_Gzdd_AKbU": "Valor do ajuste do posto",
  "GDriver_0714_rBxk_CstO": "Precisa melhorar",
  "Internal_Tools_B_MhcJ_rfQv": "Detalhes da estratégia de desconto",
  "GDriver_Rate_loVu_PxhD": "Ver faturas associadas",
  "Internal_Tools_B_ajlo_HnqP": "Registro de ações",
  "Internal_Tools_B_muPj_LeXe": "Saldo da {{Brand_Name}}",
  "Internal_Tools_B_iLJS_uUwa": "Combustível em exibição",
  "Internal_Tools_B_bNEi_MfAw": "Cancelar",
  "GDriver_0714_AnRO_kLNJ": "Categoria",
  "Internal_Tools_B_HOMP_Jysk": "Combustível não exibido",
  "Internal_Tools_B_HHxf_GgTF": "Horário",
  "Internal_Tools_3_SBhz_EZXw": "Nome do posto",
  "Internal_Tools_2_oDlf_fVsf": "Hora do abastecimento",
  "Internal_Tools_2_onjK_xaqD": "Volume total de combustível gasoso de todos os abastecimentos nas condições selecionadas",
  "GDriver_Rate_FmgF_CgeQ": "1. Valor de campo fixo: gerado com base na condição selecionada na caixa de filtro. Ao selecionar “Tudo”, o valor do campo se tornará “Tudo”. Ao selecionar uma condição específica, as informações correspondentes a essa opção serão mostradas na lista.",
  "Internal_Tools_2_eyOs_aAPw": "Informações do anexo",
  "Internal_Tools_2_GaFz_pQZZ": "Filtre e selecione o abastecimento que você acha que tem um problema no valor e insira o valor esperado.",
  "Internal_Tools_B_ceeV_dRMo": "Data do débito",
  "Internal_Tools_B_upfK_Vzsc": "Insira",
  "Internal_Tools_2_mmuK_qILh": "Líquido",
  "Internal_Tools_B_lWRy_tGTo": "Data",
  "Internal_Tools_B_zpbB_XOiB": "Combustível indisponível no momento",
  "Internal_Tools_2_IlQz_mEGK": "Preço unitário original",
  "Internal_Tools_B_Hfjm_aSzt": "Cancelar",
  "Internal_Tools_B_ZWnL_NxIT": "Descrição",
  "Internal_Tools_B_SECS_XFym": "Confirmado com sucesso",
  "GDriver_Rate_VFLy_nWaE": "O valor da fatura não mudou. Faça os ajustes antes de enviar.",
  "GDriver_0714_wkse_WUcd": "Últimos 2 meses",
  "Internal_Tools_B_iRuS_vbPU": "Em análise da {{brand_name}}",
  "Internal_Tools_B_lmzi_AdZe": "Motivo da rejeição da {{brand_name}}: {{reason}}",
  "Internal_Tools_B_jGdF_dNpY": "A fatura de {{Gas_Station_Name}} ({{Bill_Periods}}) foi enviada para o {{brand_name}}Abastece, e o valor da fatura é {{Bill_Amount}}. Para receber o pagamento no prazo, confirme assim que possível.",
  "Internal_Tools_B_yzcd_HgnA": "Em andamento",
  "GDriver_B_RWAU_ZILl": "Termos e Condições",
  "Internal_Tools_B_IYOZ_iwAq": "Horário da ação",
  "Internal_Tools_B_FKdd_ahtc": "Essa nota de débito foi gerada automaticamente pela {{brand_name}}.",
  "Internal_Tools_B_Dlhh_BgJZ": "Baixar conta detalhada por e-mail",
  "GDriver_0714_lkkl_OJoY": "Problemas mais mencionados nas avaliações",
  "GDriver_0714_YIVT_ofZZ": "Avaliações mais altas geram mais movimento",
  "Internal_Tools_B_EGqI_BLrf": "Analisar registro",
  "Internal_Tools_2_NGLr_hhOD": "O recurso de exibição não está disponível em dispositivos móveis. Use a versão para PC.",
  "Internal_Tools_B_NVMK_FtoH": "Posto de gasolina",
  "Internal_Tools_B_etLT_XTcj": "(ajustado pelo posto)",
  "GDriver_B_eSPa_nCyq": "{{Page_num}} / página",
  "GDriver_Rate_xJny_zMFD": "Não há dados disponíveis",
  "GDriver_0714_oPVR_DxsH": "Principais tags de avaliações de 1 estrela",
  "Internal_Tools_B_zluz_RSQE": "Programa {{brand_name}}Abastece",
  "GDriver_0714_Wiqi_rsXT": "Melhoria",
  "Internal_Tools_B_IRRc_hZIm": "Inválida",
  "Internal_Tools_B_hRqn_QiwT": "Informações de faturamento",
  "Internal_Tools_3_thwC_VgKl": "Veja todas as entradas antes de confirmar",
  "GDriver_0714_QOxf_sbuG": "Confirmar",
  "Internal_Tools_B_BRqr_VajR": "Item de ajuste de fatura",
  "Internal_Tools_3_Cdzx_KDff": "De segunda a sexta, das 8h às 18h",
  "Internal_Tools_3_AUkL_uYJd": "Etapa 2: Enviar arquivo do modelo",
  "GDriver_B_VMvB_MrxF": "Data",
  "Internal_Tools_B_ZNba_eOJt": "(até cinco registros podem ser exibidos)",
  "Internal_Tools_B_WZtb_VmSM": "Nº",
  "Internal_Tools_3_QEFE_kxrV": "Os preços após o desconto de {{number}} combustível(is) ultrapassam em 25% os preços originais. Reconfirme.",
  "GDriver_B_nwAp_Bahp": "A conta não existe. Use outra conta.",
  "GDriver_0714_hIJz_Enis": "Neutras",
  "Internal_Tools_B_aTmx_JssU": "Análise da {{brand_name}}",
  "Internal_Tools_B_SidT_WnWJ": "Apagar",
  "GDriver_Rate_viTB_cjDd": "Observações",
  "Internal_Tools_2_mxFS_VTNj": "O combustível líquido é medido em litros; o combustível gasoso, em metros cúbicos.",
  "Internal_Tools_B_ZURF_RCND": "Quer mesmo salvar esse ajuste de desconto do posto de gasolina? Depois de salvar, o novo desconto se tornará válido imediatamente.",
  "GDriver_0714_yTiI_GIeu": "Exibição da interface do usuário",
  "Internal_Tools_B_tPhY_EMCr": "ID da fatura",
  "GDriver_Rate_mEjS_xsaH": "Valor do pagamento",
  "Internal_Tools_3_eUjQ_yIOl": "Usar modelo para importar descontos",
  "Internal_Tools_B_OLQx_vawS": "Indica se o combustível é mostrado para os usuários no {{brand_name}}Abastece",
  "Internal_Tools_B_ZHCN_sXeT": "Cancelar",
  "GDriver_B_qyne_lALc": "Nome do usuário",
  "Internal_Tools_B_tILQ_yJAG": "Cancelar",
  "Internal_Tools_2_lyyB_vPzq": "Seu ajuste de valor (de {{bill_amount}} para {{bill_adjusted_amount}}) foi rejeitado pela {{brand_name}}. Faça as alterações com base no motivo da rejeição e depois reenvie a confirmação.",
  "Internal_Tools_B_RNhD_qhCK": "Reconciliação e pagamento",
  "Internal_Tools_B_GEJX_hrvH": "Informe o motivo para deixar de exibir",
  "Internal_Tools_B_gDNW_jILR": "Plataforma {{brand_name}}",
  "Internal_Tools_2_YPte_IwOE": "Gasoso",
  "Internal_Tools_2_aeNy_MYVh": "Mês",
  "Internal_Tools_2_Pafp_fpyb": "Envie detalhes do abastecimento ou outra documentação para justificar o ajuste.",
  "Internal_Tools_3_hDav_blKk": "Baixar",
  "GDriver_0714_geGf_VDLP": "Total",
  "Internal_Tools_B_ooUz_fFmX": "Ações",
  "GDriver_0714_vWAe_hjDV": "Distribuição de tags de avaliação",
  "Internal_Tools_2_RxEZ_ESeX": "Insira o valor de pagamento esperado após o ajuste",
  "Internal_Tools_B_GzFj_Nlnu": "Valor do ajuste do posto",
  "Internal_Tools_B_qtns_OWdE": "QT",
  "Internal_Tools_B_pLXk_EZcF": "Esse é o preço estimado. O preço real pago pelos usuários após o desconto pode ser diferente por causa dos ajustes feitos pela {{brand_name}}.",
  "GDriver_B_tuUz_ZGks": "Semana passada",
  "GDriver_B_QaJz_nHMx": "Faturas",
  "Internal_Tools_B_btqY_oyra": "Registro de alterações de desconto",
  "Internal_Tools_2_QKQx_ephy": "Ver no celular",
  "Internal_Tools_4_fhfu_QNpo": "Envie um arquivo .xlsx (até 10 MB)",
  "GDriver_Rate_pKeD_TLlw": "Desconto {{Platform_name}}",
  "Internal_Tools_B_rJTV_GFwt": "Editar",
  "Internal_Tools_B_oVBD_xPFJ": "Não exibir",
  "Internal_Tools_2_ANJX_viUn": "Total com desconto",
  "Internal_Tools_2_Yexl_qwtW": "{{num}} abastecimento(s) ajustado(s)",
  "Internal_Tools_B_XADb_rGKq": "Status",
  "Internal_Tools_B_FcHg_Nkhf": "Plataforma {{brand_name}}",
  "Internal_Tools_B_jMpQ_MhBZ": "Última atualização em {{time}}",
  "Internal_Tools_B_vETe_JGNb": "Desconto de valor fixo",
  "Internal_Tools_B_ZToB_JbPm": "Enviar",
  "GDriver_B_BJTU_VFFp": "Valor total de todos os abastecimentos após a aplicação de descontos nas condições selecionadas",
  "Internal_Tools_B_XbZk_Lagw": "Itens negados:",
  "Internal_Tools_B_atoO_Ssnn": "Editar",
  "GDriver_B_SWsZ_SxEV": "Valor total do desconto = desconto {{Brand_Name}} + desconto do posto de gasolina",
  "GDriver_B_LRmo_qQTO": "Desconto {{Brand_Name}}",
  "GDriver_0714_ybdp_kBfR": "Contagem de avaliações",
  "GDriver_B_MyJy_Qfir": "Valor total após a aplicação do desconto",
  "Internal_Tools_2_uYtG_HGQZ": "Selecione o horário",
  "GDriver_B_OZRC_vJMU": "Sair",
  "Internal_Tools_2_vYnH_dgVv": "Sua solicitação foi rejeitada pela {{brand_name}}. Faça as alterações com base no motivo da rejeição e depois reenvie a confirmação.",
  "Internal_Tools_2_ANMs_tYaS": "Jun",
  "Internal_Tools_B_qOau_cxQf": "Relatório de abastecimentos",
  "GDriver_0714_HBtB_NHqD": "Ver tudo"
}